/**
 * Maps a value (`v`) from one range (`e` to `g`) to another range (`a` to `n`).
 * Returns a corresponding value in the new range, or `undefined` if conditions are not met.
 * 
 * @param {number} v - The value to map.
 * @param {number} e - The start of the first range.
 * @param {number} g - The end of the first range.
 * @param {number} a - The start of the second range.
 * @param {number} n - The end of the second range.
 * @returns {number|undefined} The mapped value, or `undefined` if no valid mapping exists.
 */
export function map(v,e,g,a,n){return e>g?e>v?(v-e)*(n-a)/(g-e)+a:a:g>e?g>v?(v-e)*(n-a)/(g-e)+a:n:void 0;}
